// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantListHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var EventUtils = require('share/utils/Izenda.EventUtils');
  var SearchTextBox = require('share/components/controls/Izenda.SearchTextBox');
  var config = require('config');

  /**
   * Tenant List Header
   * @param {object} props The component's props that must have 'store' property
   */
   var TenantListHeader = function (props) {
     var store = props.store;
     var tenantList = store.tenantList;
     var addTenant = function () {
       props.validation.reset();
       store.addTenant();
     };
     var updateFilter = store.updateFilterText.bind(store);
     var localization = props.localization;
     var authorization = props.authorization;
     var permissionKeys = props.authorizationConstants.PERMISSION_KEY;
     var hasCreatePrivilege = authorization.checkPrivileges([permissionKeys.TenantSetupActionsCreate]);
     var canCreateTenant = hasCreatePrivilege && !config.Integration;

     return (
       <div className="izenda-MiddlePanel-search">
         {canCreateTenant && <a
           className="overflow-text u_block"
           onClick={addTenant}
           title={localization.getText('TENANT_LIST_HEADER_ADD_TENANT')}>
           <span className="icon-plus" />
           {localization.getText('TENANT_LIST_HEADER_ADD_TENANT')}
         </a>}
         <div className="search-box">
           <SearchTextBox
             value={tenantList.filterText}
             onChange={EventUtils.notifyChange(updateFilter, EventUtils.INPUT)}/>
         </div>
         <hr />
       </div>
     );
   };
  TenantListHeader.propTypes = {
    store: React.PropTypes.object.isRequired
  }

  module.exports = connect()(TenantListHeader);
}();



// WEBPACK FOOTER //
// ./ui/modules/Settings/TenantManagement/Izenda.TenantListHeader.jsx